/**
 * Specifies whether the ReturnRatePrice(42767) is expressed in absolute or relative terms.
 * tag: 42769
 * @readonly
 * @enum {number} (int)
 */
export enum ReturnRatePriceType {
  /** Absolute terms */
  AbsoluteTerms = 0,
  /** Percentage of notional */
  PercentageOfNotional = 1,
}
